export default __webpack_public_path__ + "src/assets/confirm.817cbaa559a9cb4de97ddd05414fab9d.svg";